import type { DriveStep } from 'driver.js';

export const calendarTourSteps: DriveStep[] = [
  {
    element: '[data-tour="cal-tabs"]',
    popover: {
      title: 'Drei Bereiche',
      description: 'Kalender zeigt deine Termine. Verfügbarkeiten definieren, wann Klienten buchen können. Buchungen zeigt alle eingehenden Terminanfragen.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="cal-new-event"]',
    popover: {
      title: 'Neuen Termin anlegen',
      description: 'Erstelle manuell einen neuen Termin — mit Klient, Ort und optionalem Zoom-Link.',
      side: 'bottom',
      align: 'end',
    },
  },
  {
    element: '[data-tour="cal-view-modes"]',
    popover: {
      title: 'Ansichtsmodus',
      description: 'Wechsle zwischen Monats-, Wochen- und Listenansicht — je nachdem was dir lieber ist.',
      side: 'bottom',
      align: 'end',
    },
  },
  {
    element: '[data-tour="cal-reminders"]',
    popover: {
      title: 'Erinnerungen versenden',
      description: 'Verschicke automatische Termin-Erinnerungen per E-Mail an alle Klienten mit anstehenden Terminen.',
      side: 'bottom',
      align: 'end',
    },
  },
];
